var _path, _circle;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgEyeGrey = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 16,
    viewBox: "0 0 18 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.14286 9.14286C5.92995 12.93 12.07 12.93 15.8571 9.14286C16.4883 8.51167 16.4883 7.48833 15.8571 6.85714C12.07 3.07005 5.92995 3.07005 2.14286 6.85714C1.51167 7.48833 1.51167 8.51167 2.14286 9.14286Z",
    stroke: "#9AA5B1",
    strokeWidth: 1.5
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 9,
    cy: 8,
    r: 1.5,
    fill: "#9AA5B1",
    stroke: "#9AA5B1"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgEyeGrey);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/eye-grey.d72ccfacf38aef3bc5fdb4f287dc09fa.svg";